import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import ItemElement from '../ItemElement';
import HeaderIcon from './components/HeaderIcon';

var Review = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Review, _React$PureComponent);

  function Review() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Review.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        as = _this$props.as,
        author = _this$props.author,
        company = _this$props.company,
        text = _this$props.text,
        charLimit = _this$props.charLimit,
        image = _this$props.image,
        cardInlinePhoto = _this$props.cardInlinePhoto,
        imageCircular = _this$props.imageCircular,
        imageSize = _this$props.imageSize,
        itemButtonFloat = _this$props.itemButtonFloat,
        itemCenterContent = _this$props.itemCenterContent,
        link = _this$props.link,
        linkAs = _this$props.linkAs,
        verticalItemAlign = _this$props.verticalItemAlign;
    return /*#__PURE__*/React.createElement(ItemElement, {
      as: as,
      header: author,
      headerIcon: link ? /*#__PURE__*/React.createElement(HeaderIcon, {
        link: link,
        showLink: linkAs !== 'header',
        isVerticalItem: as === 'verticalItem'
      }) : null,
      subheader: company,
      content: text,
      charLimit: charLimit,
      image: image,
      cardInlinePhoto: cardInlinePhoto,
      imageCircular: imageCircular,
      imageSize: imageSize,
      itemButtonFloat: itemButtonFloat,
      itemCenterContent: itemCenterContent,
      link: link,
      linkAs: linkAs,
      verticalItemAlign: verticalItemAlign,
      event: {
        category: 'Reviews',
        action: 'click',
        label: 'See more'
      }
    });
  };

  return Review;
}(React.PureComponent);

export { Review as default };
Review.defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 280,
  company: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  author: '',
  verticalItemAlign: 'center'
};